export default {
	"ProductInfo.GrowBeans": "Grow beans",
	"ProductInfo.SubscriptionUpgrade": "Subscription upgrade"
}